import { Type } from 'class-transformer';
import { SiteInfrastructure } from './site-infrastructure.class';

export class SimulationInfrastructure {
	organizationId: string;
	simulationId: string;

	@Type(() => SiteInfrastructure)
	siteInfrastructure: SiteInfrastructure[];
}
